import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const PRODUCT_TOKEN_KEY = 'coretiq-product-token';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const productToken = getProductToken();
  if (productToken) {
    config.headers.Authorization = `Bearer ${productToken}`;
  }
  return config;
});

export const getProductToken = () => localStorage.getItem(PRODUCT_TOKEN_KEY) || '';

export const setProductToken = (token) => {
  if (token) localStorage.setItem(PRODUCT_TOKEN_KEY, token);
  else localStorage.removeItem(PRODUCT_TOKEN_KEY);
};

const productHeaders = () => ({
  Authorization: `Bearer ${getProductToken()}`,
});

export const healthCheck = () =>
  api.get('/health').then(r => r.data);

export const validateSingle = (freitext, icd_code) =>
  api.post('/validate', { freitext, icd_code }).then(r => r.data);

export const validateBatch = (entries, filename = 'batch-pruefung') =>
  api.post('/validate/batch', { entries, filename }).then(r => r.data);

export const validateCSV = (fileContent, filename = 'csv-upload.csv') =>
  api.post('/validate/csv', fileContent, {
    headers: { 'Content-Type': 'text/plain' },
    params: { filename },
  }).then(r => r.data);

export const loginProduct = (email, password) =>
  api.post('/auth/login', { email, password }).then(r => {
    setProductToken(r.data.access_token);
    return r.data;
  });

export const fetchMe = () =>
  api.get('/me', { headers: productHeaders() }).then(r => r.data);

export const fetchDashboard = () =>
  api.get('/dashboard', { headers: productHeaders() }).then(r => r.data);

export const fetchAdminDashboard = () =>
  api.get('/admin/dashboard', { headers: productHeaders() }).then(r => r.data);

export const fetchUsers = () =>
  api.get('/admin/users', { headers: productHeaders() }).then(r => r.data);

export const createUser = (user) =>
  api.post('/admin/users', user, { headers: productHeaders() }).then(r => r.data);

export const updateUser = (userId, updates) =>
  api.patch(`/admin/users/${userId}`, updates, { headers: productHeaders() }).then(r => r.data);

export const setUserPassword = (userId, newPassword) =>
  api.post(`/admin/users/${userId}/password`, { new_password: newPassword }, { headers: productHeaders() }).then(r => r.data);

export const changePassword = (currentPassword, newPassword) =>
  api.post('/auth/change-password', {
    current_password: currentPassword,
    new_password: newPassword,
  }, { headers: productHeaders() }).then(r => r.data);

export const saveProfile = (profile) =>
  api.put('/product/profile', profile, { headers: productHeaders() }).then(r => r.data);

export const recordUpload = (upload) =>
  api.post('/product/uploads', upload, { headers: productHeaders() }).then(r => r.data);

export const fetchCompliance = () =>
  api.get('/product/compliance', { headers: productHeaders() }).then(r => r.data);

export const downloadPdfReport = (jobId) =>
  api.get(`/reports/${jobId}.pdf`, {
    headers: productHeaders(),
    responseType: 'blob',
  }).then(r => {
    const blob = new Blob([r.data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `icd10-report-${jobId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  });

export default api;
